export const TEXT_EDITOR_VIDEO_EMBED = 'text-editor-video-embed';
export const SHARE_URL = 'share-url-modal';
export const ABOUT_EDIT_DISCARD = 'about-edit-discard';
export const SUCCESS_MESSAGE_NOTIFICATION = 'success-message';
export const MANAGE_BADGES = 'manage-badges';
export const PROFILE_PREVIEW_NOTIFICATION = 'profile-preview-notification';
export const INFO_NOTIFICATION = 'info-notification';
export const THANKS_FOR_REPORT = 'thanks-for-report';
export const REPORT_MEMBER = 'report';
